import { faInfoCircle } from '@fortawesome/pro-solid-svg-icons/faInfoCircle';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import styled from 'styled-components';

type Props = {
    onClick: (event: any) => void;
};

const InfoBadge = ({ onClick }: Props) => <InfoIcon icon={faInfoCircle} onClick={onClick} />;
export default InfoBadge;

const InfoIcon = styled(FontAwesomeIcon)`
    font-size: 12px;
    color: ${({ theme }) => theme.colors.grey100};
    cursor: pointer;
`;
